import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SecondHandSupply } from '../../models/second-hand-supply';

@Component({
  selector: 'app-view-reason',
  templateUrl: './view-reason.component.html',
  styleUrls: ['./view-reason.component.scss']
})
export class ViewReasonComponent implements OnInit {

    /* --------------------------------- FIELDS -------------------------------- */
/* ------------------------------- CONSTRUCTOR ------------------------------ */
constructor(
  private _dialogRef: MatDialogRef<ViewReasonComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SecondHandSupply,
    ) { }
    /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
    ngOnInit() {
    }
    /* ------------------------------ CUSTOM-METHODS ----------------------------- */
    closeDialog() {
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
    }
    /* --------------------------------- GETTERS --------------------------------- */
    }
